<div *ngIf="currentJob" class="bmc-jobs-detail__container bz-color-bg--neutral-100 bz-space--inset-l">
  <div class="bmc-jobs-detail__content">
    <div class="bz-space--stack-xl bmc-jobs-detail__header bz-font-weight--semibold">
      {{title | translate}}
      <bzg-icon class="bmc-jobs-detail__icon-close" [nameIcon]="'icon-close'" [size]="22" (click)="validatePendingChanges(currentJob)">
      </bzg-icon>
    </div>
    <div class="bmc-jobs-detail__loading-container" *ngIf="isLoading">
        <bz-loading [size]="'m'" class="bmc-jobs-table__loading">
          {{ 'GLOBAL.LOADING_DATA' | translate }}</bz-loading>
      </div>
    <bzg-tab-set *ngIf="!isLoading">
      <bzg-tab-item displayName="{{'USERJOBS.SETTINGS' | translate | uppercase}}">
        <job-settings
        [currentJob]="currentJob"
        (saveJob)="updateJob($event)"
        (cancel)="validatePendingChanges(currentJob)"
        [applyDisabled]="isLoading"></job-settings>
      </bzg-tab-item>
      <bzg-tab-item displayName="{{'USERJOBS.JOB_STEPS' | translate | uppercase}}">
        <job-steps [jobType]="jobType" [currentJob]="currentJob"></job-steps>
      </bzg-tab-item>
      <bzg-tab-item displayName="{{'USERJOBS.JOB_SCHEDULES' | translate | uppercase}}">
        <job-schedules [currentJob]="currentJob" [jobType]="jobType" ></job-schedules>
      </bzg-tab-item>
      <bzg-tab-item displayName="{{'USERJOBS.JOB_EXECUTION' | translate | uppercase}}">
        <job-execution [jobType]="jobType" [jobId]="currentJob.id"></job-execution>
      </bzg-tab-item>
    </bzg-tab-set>
  </div>

</div>
